import {Howl} from "howler";
import { Constants, Interfaces } from "@ambifi/ambifi-synthetic-voice";
// Howler.autoUnlock = false;
// const Sound = {};

const { SyntheticVoiceAudioProvider } = Interfaces;
const { EVENT_TYPE_SPEECH_START, EVENT_TYPE_SPEECH_FINISH } = Constants;

let AUDIO_RATE = 1.0;

const PROVIDER_VOICE_SPEEDS = {
	[Constants.VOICE_SPEED_SLOWEST]: 0.65,
	[Constants.VOICE_SPEED_SLOWER]: 0.75,
	[Constants.VOICE_SPEED_SLOW]: 0.85,
	[Constants.VOICE_SPEED_NORMAL]: 1.0,
	[Constants.VOICE_SPEED_FAST]: 1.3,
	[Constants.VOICE_SPEED_FASTER]: 1.6,
	[Constants.VOICE_SPEED_FASTEST]: 1.9
};
class AudioProvider extends SyntheticVoiceAudioProvider {
	constructor() {
		super();
		this.currentSound = null;
		this.paused = false;
	}

	_onAudioStart() {
		// console.log("START EVENT (Tts) speech request", this);
		this.fireEvent(EVENT_TYPE_SPEECH_START);
	}
	_onAudioEnd() {
		// console.log("FINISH EVENT (Tts) speech request", this);
		if (this.currentSound && this.currentSound.release) {
			this.currentSound.release();
		}
		this.fireEvent(EVENT_TYPE_SPEECH_FINISH);
	}

	start(speechRequest) {
		const { url } = speechRequest;
		return this.play(url);
	}

	play(url) {
		const self = this;
		this._onAudioStart();
		return new Promise(async (resolve, reject) => { // eslint-disable-line no-async-promise-executor
			try {
				this.fireEvent(EVENT_TYPE_SPEECH_START);
				if (self.currentSound !== null) {
					self.currentSound.stop(async () => {
						await self.playOnly(url);
					});
				} else {
					await self.playOnly(url);
				}
				self._onAudioEnd();
				resolve();
			} catch (e) {
				reject(e);
			}

		});

	}

	playOnly(url) {
		const self = this;
		return new Promise((resolve, reject) => {
			// console.log("Play URI", url);
			if (!url) {
				reject("A URL is required in order to play a sound.");
			}

			let src = [url];
			if (src && src.hasOwnProperty("uri")) {
				src = [src.uri];
			}

			// if (_uri.startsWith("file://")) {
			// 	_uri = require(_uri);
			// }
			const errorFn = (e) => {
				const message = url === "init" ? "initialized audio" : "playback failed due to audio decoding errors";
				console.warn(message, e);
				reject(message);
			};
			self.currentSound = new Howl({
				src,
				html5: true,
				preload: true,
				onend: () => {
					// console.log("successfully finished playing");
					resolve();
				},
				onloaderror: errorFn,
				onplayerror: () => {
					self.currentSound.once("unlock", () => {
						self.currentSound.play();
					});
				}
			});
			self.currentSound.rate(AUDIO_RATE);

			self.currentSound.play();

			// self.currentSound = new Howl(src, "", (error) => {
			// 	// console.log("Instantiated new Sound", src, error);
			// 	if (error) {
			// 		console.warn("failed to load the sound", error);
			// 		reject(error);
			// 		return;
			// 	}
			// 	// loaded successfully
			// 	// console.log("duration in seconds: " + self.currentSound.getDuration() + "number of channels: " + self.currentSound.getNumberOfChannels());

			// 	// Play the sound with an onEnd callback
			// 	self.currentSound.play((success) => {
			// 		if (success) {
			// 			// console.log("successfully finished playing");
			// 			resolve();
			// 		} else {
			// 			const message = "playback failed due to audio decoding errors";
			// 			console.warn(message);
			// 			reject(message);
			// 		}
			// 	});


			// });
		});
	}

	togglePauseResume() {
		if (this.paused) {
			this.resume();
		} else {
			this.pause();
		}
	}

	isPlaying() {
		if (this.currentSound.getCurrentTime() < this.currentSound.getDuration()) {
			return true;
		} else {
			return false;
		}
	}

	pause() {
		if (!this.paused) {
			this.paused = true;
			if (this.currentSound !== null) {
				this.currentSound.pause();
			}
		}
	}

	resume() {
		if (this.paused) {
			this.paused = false;
			if (this.currentSound !== null) {
				this.currentSound.play();
			}
		}
	}

	stop() {
		this.paused = false;
		if (this.currentSound !== null) {
			this.currentSound.stop();
			this._onAudioEnd();
		}
	}

	static setDefaultSpeed(speed) {
		const speedConstant = SyntheticVoiceAudioProvider.getSpeedConstantFromValue(speed);
		console.log("Setting audio speech rate", speed);
		AUDIO_RATE = PROVIDER_VOICE_SPEEDS[speedConstant];
	}
}

export default AudioProvider;